'use strict';
var React = require('react');

class CategoriesHomeComponent extends React.Component {
    renderCategories() {
        var self = this;
        var loadCategories = (self.props.collapsableCategories === 'true'
            && self.props.numberOfCategories === 4) ? 6 : self.props.numberOfCategories;
        var categoryViews = self.props.categories.slice(0, loadCategories).map(function (item, index) {
            const mediaUrl = item.Media != null && item.Media[0] != null ? item.Media[0].MediaUrl : '';
            return (
                /*<div className="col-md-2 col-sm-6 col-xs-12 xs-mb-15" key={item.ID}>
                    <a href={"/search?categories=" + item.ID} className="category-box">
                        <div className="img-box">
                            <div className="background-image-holder" style={{ background: 'rgba(0, 0, 0, 0) url("' + mediaUrl + '") repeat scroll 0% 0%' }}>
                                <img src={mediaUrl} alt={item.Name} title={item.Name} style={{ display: 'none', maxHeight: 200 + 'px' }} />
                            </div>
                        </div>
                        <h4 className="category-name">{item.Name}</h4>
                    </a>
                </div>*/
                <div className="col-md-2 col-sm-6 col-xs-12 xs-mb-15" key={item.ID}>
                    <a href={"/search?categories=" + item.ID} className="category-box">
                        <div className="bp-img-box">
                            <div className="bp-background-image-holder" style={{ background: 'rgba(0, 0, 0, 0) url("' + mediaUrl + '") no-repeat 0%' }}>
                                <img src={mediaUrl} alt={item.Name} title={item.Name} style={{ display: 'none', maxHeight: 200 + 'px' }} />
                            </div>
                           <div className="bp-category-name-box"> 
                           <h4 className="category-name">{item.Name}</h4>
                           <span className="bp-goto-category">Navega nuestra categoria  <img alt="" src="/assets/images/bepensa/right-arrow.svg" className="bp-goto-category-arrow"></img></span>
                           </div>
                        </div>
                        
                    </a>
                </div>
                );
        });
        return categoryViews;
    }

    renderCategoriesCarrousel() {
        var self = this;  
        
        return (<div className="myoffers-carousel" data-slick='{"slidesToShow": 6, "slidesToScroll": 6}'>

            {this.props.categories.map(function (item, index) {
                if(item.Name != "Ofertas" && item.Name != "Marca") {
                    var mediaUrl = item.Media != null && item.Media[0] != null ? item.Media[0].MediaUrl : '';
                    return (
                        <div className="col-md-2 col-sm-6 col-xs-12 xs-mb-15" key={item.ID}>
                            <a href={"/search?categories=" + item.ID} className="category-box item-categories-carousel">
                                <div className="bp-img-box">
                                    <div style={{width:'100%', height: '210px'}}>
                                        <img alt="" className="bp-background-image-holder img-category" src={mediaUrl} style={{ backgroundRepeat: 'no-repeat 0%'}} />
                                    </div>
                                    
                                   { /*<div className="bp-background-image-holder" style={{ background: 'rgba(0, 0, 0, 0) url("' + mediaUrl + '") no-repeat 0%' }}>
                                        
                                    </div>*/}
                                    <div className="bp-category-name-box"> 
                                        <h4 className="category-name category-name-carousel">{item.Name}</h4>
                                        <span className="bp-goto-category bp-goto-category-carousel">Navega nuestra categoría  <img alt="" src="/assets/images/bepensa/right-arrow.svg" className="bp-goto-category-arrow"></img></span>
                                    </div>
                                </div>    
                            </a>
                        </div>
                    );
                }
            })}
            
        </div> 
        
        )
    }

    renderToggleViewMore() {
        var self = this;
        if (self.props.collapsableCategories === 'true') {
            if (self.props.numberOfCategories == self.props.categories.length && self.props.categories.length > 4) {
                return (<div className="vew-more-btn text-center">
                    <div className="more-btn" id="viewMoreCat" onClick={(e) => self.props.loadLess()}>View Less</div>
                </div>)
            } else {
                return (<div className="vew-more-btn text-center">
                    <div className="more-btn" id="viewMoreCat" onClick={(e) => self.props.loadMore()}>View More</div>
                </div>)
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="bp-section-title">
                    <h3>Descubre nuestras categorías</h3>
                    <div className="divider"></div>
                </div>
                <div className="section-category-list">
                    {/*this.renderCategories()*/ this.renderCategoriesCarrousel()}
                    {/*this.renderToggleViewMore()*/}
                </div>
            </React.Fragment>
        );
    }
}

module.exports = {
    CategoriesHomeComponent
}
